export default "__VITE_ASSET__2567db9b__"